import { AxiosError } from 'axios';
import { MutationFunction, useMutation } from '@tanstack/react-query';

export function usePost<TData, TVariables, TError = AxiosError>(
  fn: MutationFunction<TData, TVariables>,
  onSuccess?: (data: TData) => void | Promise<void>,
  onError?: (error: TError) => void | Promise<void>
) {
  const mutation = useMutation<TData, TError, TVariables>({
    mutationFn: fn,
    onError: (error) => {
      onError ? onError(error) : console.log(error);
    },
    onSuccess: (data) => {
      onSuccess ? onSuccess(data) : console.log(data);
    },
  });
  return mutation;
}
